declare global {
  interface Set<T> {
    difference(other: Set<T>): Set<T>;
  }
}

if (!Set.prototype.difference) {
  Set.prototype.difference = function <T>(other: Set<T>): Set<T> {
    const result = new Set(this);
    for (const elem of other) {
      result.delete(elem);
    }
    return result;
  };
}
